import { supabase } from '../supabase/supabaseClient'

// One racing ticket (racing-ticket edge function), shared by the odds WebSocket
// and the flucs REST calls. Reused until shortly before it expires, so a page
// that refreshes flucs every 15s isn't minting a ticket every time.
const MARGIN_MS = 30 * 1000
const FALLBACK_LIFE_MS = 60 * 1000     // an older edge function that doesn't send expires_in

let cached = null      // { ticket, until }
let pending = null

// A ticket belongs to one user: never hand it to the next one to sign in.
supabase.auth.onAuthStateChange((event) => {
  if (event === 'SIGNED_OUT' || event === 'SIGNED_IN') cached = null
})

// Resolves { ticket } or { ticket: null, noAccess } (noAccess = 403, the plan has no racing).
export function getRacingTicket() {
  if (cached && Date.now() < cached.until) return Promise.resolve({ ticket: cached.ticket })
  if (!pending) {
    pending = (async () => {
      const issued = Date.now()
      const { data, error } = await supabase.functions.invoke('racing-ticket')
      if (error) return { ticket: null, noAccess: error.context?.status === 403 }
      const life = data.expires_in ? data.expires_in * 1000 : FALLBACK_LIFE_MS
      cached = { ticket: data.ticket, until: issued + life - MARGIN_MS }
      return { ticket: data.ticket }
    })().finally(() => { pending = null })
  }
  return pending
}

// The API turned this ticket down (401, or the socket closed before opening): get a new one next time.
export function dropRacingTicket(ticket) {
  if (cached?.ticket === ticket) cached = null
}
